import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoalService } from 'app/services/coal.service';

@Component({
    selector: 'app-wiz-expedicion',
    templateUrl: './wiz-expedicion.component.html',
    styleUrls: ['./wiz-expedicion.component.scss']
})
export class WizExpedicionComponent implements OnInit {
    @Input() lugarExpedicionForm: FormGroup;
    @Output() cpValidChange = new EventEmitter<boolean>(); // Agregar el EventEmitter para emitir el estado de CP
    
    lstEstado: any[] = [];
    lstPais: any[] = [];            // Define la lista de países
    lstMunicipio: any[] = [];       // Define la lista de municipios
    lstAsentamiento: any[] = [];    // Define la lista de colonias
    isEstadoReadOnly: boolean = false;
    isPaisReadOnly: boolean = false;       // Define la propiedad para controlar la edición del país
    isMunicipioReadOnly: boolean = false;  // Define la propiedad para controlar la edición del municipio
    isColoniaManual: boolean = false;      // Define la propiedad para controlar si la colonia se ingresa manualmente
    opcionales: boolean = false;

    constructor(
        private _formBuilder: FormBuilder,
        private coalService: CoalService
    ) { }

    ngOnInit(): void {
        if (this.lstEstado.length === 0) {
            this.getEstados();
        }
        this.getPaises();  // Llamar la función para obtener los países
    }

    getEstados() {
        this.coalService.getService('dir-estados?filters[dir_pai][idPais][$eq]=MEX')
            .subscribe((res: any) => {
                this.lstEstado = res.data;
            }, (error: any) => {
                // Manejo de errores, mostrar mensaje, etc.
            });
    }

    getPaises() {
        this.coalService.getService('dir-paises?pagination[pageSize]=5000')
            .subscribe((res: any) => {
                this.lstPais = res.data;
            }, (error: any) => {
                // Manejo de errores, mostrar mensaje, etc.
            });
    }
    
    
    onCPBlur(): void {
        const cpControl = this.lugarExpedicionForm.get('CP');
        
        // Forzar la ejecución de la validación y limpiar errores previos
        cpControl?.updateValueAndValidity();
        
        if (cpControl && cpControl.value && cpControl.valid) {
            this.consultaSepomex();
        } else {
            // Emitir false si el CP es inválido o está vacío
            this.cpValidChange.emit(false);
            cpControl?.setErrors({ invalidFormat: true });
        }
    }
    

    async consultaSepomex() {
        try {
            if (!this.lugarExpedicionForm.controls.CP.valid) {
                this.cpValidChange.emit(false); // Emitir false si el CP no es válido
                return;
            }
            const CP = this.lugarExpedicionForm.value.CP;
    
            const res = await this.coalService.getService(`dir-codigos-postales?filters[cp]=${CP}&populate[0]=dir_asentamiento.dir_municipio.dir_estado.dir_pai`).toPromise() as any;
            if (res.data && res.data.length > 0) {
                const { dir_asentamiento } = res.data[0].attributes;
                const paisId = dir_asentamiento.data.attributes.dir_municipio.data.attributes.dir_estado.data.attributes.dir_pai.data.id;
                const estadoId = dir_asentamiento.data.attributes.dir_municipio.data.attributes.dir_estado.data.id;
                const municipioId = dir_asentamiento.data.attributes.dir_municipio.data.id;
                const asentamientoId = dir_asentamiento.data.id;
    
                this.lugarExpedicionForm.controls.pais.setValue(paisId);
                this.lugarExpedicionForm.controls.estado.setValue(estadoId);
                this.lstMunicipio = [dir_asentamiento.data.attributes.dir_municipio.data];
                this.lugarExpedicionForm.controls.municipio.setValue(municipioId);
                this.lstAsentamiento = [dir_asentamiento.data];
                this.lugarExpedicionForm.controls.colonia.setValue(asentamientoId);
                this.cpValidChange.emit(true); // Emitir true si el CP es válido
            } else {
                this.resetValues();
                this.lstAsentamiento = [];
                this.lugarExpedicionForm.controls.CP.setErrors({ notFound: true });
                this.cpValidChange.emit(false); // Emitir false si el CP no se encuentra
            }
        } catch (error) {
            // Maneja el error en la llamada a la API
            this.lugarExpedicionForm.controls.CP.setErrors({ notFound: true });
            this.cpValidChange.emit(false); // Emitir false en caso de error
        }
    }
    

    resetValues() {
        this.lugarExpedicionForm.controls.estado.setValue(null);
        this.lugarExpedicionForm.controls.municipio.setValue(null);
        this.lugarExpedicionForm.controls.colonia.setValue(null);
        this.lstMunicipio = [];
        this.lstAsentamiento = [];
    }

    changePais() {
        this.getEstados(); // O lo que sea necesario hacer cuando se selecciona un país
    }

    changeEntidad() {
        const estadoId = this.lugarExpedicionForm.controls.estado.value;
        if (estadoId) {
            this.coalService.getService(`dir-municipios?filters[dir_estado]=${estadoId}`)
                .subscribe((res: any) => {
                    this.lstMunicipio = res.data;
                }, (error: any) => {
                    // Manejo de errores, mostrar mensaje, etc.
                });
        } else {
            this.resetValues();
        }
    }

    changeMunicipio() {
        const municipioId = this.lugarExpedicionForm.controls.municipio.value;
        if (municipioId) {
            this.coalService.getService(`dir-asentamientos?filters[dir_municipio]=${municipioId}`)
                .subscribe((res: any) => {
                    this.lstAsentamiento = res.data;
                }, (error: any) => {
                    // Manejo de errores, mostrar mensaje, etc.
                });
        } else {
            this.lstAsentamiento = [];
            this.lugarExpedicionForm.controls.colonia.setValue(null);
        }
    }

    toggleOpcionales() {
        this.opcionales = !this.opcionales;
    }

    changeVerManualmente(value: boolean) {
        this.isColoniaManual = value;
        this.updateControls();
    }

    updateControls() {
        if (this.isColoniaManual) {
            this.lugarExpedicionForm.controls.colonia.setValidators(null);
            this.lugarExpedicionForm.controls.colonia.updateValueAndValidity();
            this.lugarExpedicionForm.controls.coloniaManual.setValidators([Validators.required]);
            this.lugarExpedicionForm.controls.coloniaManual.updateValueAndValidity();
        } else {
            this.lugarExpedicionForm.controls.colonia.setValidators([Validators.required]);
            this.lugarExpedicionForm.controls.colonia.updateValueAndValidity();
            this.lugarExpedicionForm.controls.coloniaManual.setValidators(null);
            this.lugarExpedicionForm.controls.coloniaManual.updateValueAndValidity();
        }
    }
}